import { create } from 'zustand';

export const useMonitoringOffersStore = create<any>((set) => {
	const initialState = {
		ongoingOffers: [],
		completedOffers: [],
		specialists: [],
		categories: [],

		selectedOffer: {},
		specialistsLoading: false,
	};

	return {
		...initialState,

		setCategories: (categories: any) => set({ categories }),
		setSelectedOffer: (selectedOffer: any) => set({ selectedOffer }),
		setSpecialistsLoading: (specialistsLoading: any) => set({ specialistsLoading }),
		setSpecialists: (specialists: any) => set({ specialists }),
		setOngoingOffers: (offers: any) => set({ ongoingOffers: offers }),
		setCompletedOffers: (offers: any) => set({ completedOffers: offers }),
		clearStore: () => set(initialState),
	};
});
